import styled from 'styled-components';

export const StyledFieldset = styled.fieldset`
  border: 1px solid;
  padding: 0 1.4em 1.4em 1.4em;
  margin: 0 auto;
  margin-bottom: 1.5em;
  text-align: left;
`;

export const StyledLegend = styled.legend`
  font-weight: bold;
  text-align: left;
  width: auto;
  padding: 0 10px;
  border-bottom: none;
  font-size: 1.2rem;
  @media (max-width: 576px) {
      font-size: 0.9rem;
  }
`;